import { Button } from "@/components/ui/Button";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";

const Hero = () => {
    const { t } = useTranslation();

    return (
        <section className="relative w-full overflow-hidden bg-background">
            <div className="max-w-7xl mx-auto px-6 pt-[140px] md:pt-[160px] lg:pt-[180px] pb-16 md:pb-20 lg:pb-24">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                    <div className="lg:col-span-6 flex flex-col gap-6">
                        <span className="inline-flex w-fit items-center gap-2 px-3 py-1 rounded-full bg-accent text-accent-foreground text-sm font-medium">
                            <span className="w-1.5 h-1.5 rounded-full bg-primary" />
                            {t('app.name')}
                        </span>
                        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-[1.05] tracking-tight text-balance">
                            {t('homepage.hero.headline')}
                        </h1>
                        <p className="text-lg md:text-xl text-muted-foreground max-w-xl leading-relaxed">
                            {t('homepage.hero.subtitle')}
                        </p>
                        <div className="flex flex-wrap items-center gap-4 pt-2">
                            <Button
                                asChild
                                size="lg"
                                className="bg-primary hover:bg-primary/90 text-primary-foreground text-base px-7 py-6 rounded-full font-semibold group"
                            >
                                <Link to="/signup-creator">
                                    {t('homepage.hero.cta')}
                                    <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                                </Link>
                            </Button>
                            <Button
                                asChild
                                size="lg"
                                variant="ghost"
                                className="text-foreground hover:bg-muted text-base px-7 py-6 rounded-full font-semibold"
                            >
                                <Link to="/how-it-works">{t('nav.howItWorks')}</Link>
                            </Button>
                        </div>
                    </div>

                    <div className="lg:col-span-6 relative">
                        <div className="relative aspect-[4/5] md:aspect-[5/6] lg:aspect-[4/5] w-full overflow-hidden rounded-[2rem] shadow-2xl">
                            <img
                                src="/images/hero-mission-team.jpg"
                                alt="Mission team gathered together in service"
                                className="w-full h-full object-cover"
                                loading="eager"
                                {...{ fetchpriority: 'high' }}
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-foreground/20 via-transparent to-transparent" />
                        </div>
                        {/* Decorative warm-cream circle behind the image */}
                        <div
                            aria-hidden="true"
                            className="absolute -top-6 -right-6 w-32 h-32 md:w-40 md:h-40 rounded-full bg-accent -z-10"
                        />
                        <div
                            aria-hidden="true"
                            className="absolute -bottom-6 -left-6 w-24 h-24 md:w-32 md:h-32 rounded-full bg-primary/10 -z-10"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
